import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconArrowUp';
/** Renders an SVG icon. */
const SvgArrowUp = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 29a1 1 0 0 0 1-1V6.606l7.257 8.063a1 1 0 1 0 1.486-1.338l-9-10a1 1 0 0 0-1.486 0l-9 10a1 1 0 0 0 1.486 1.338L15 6.606V28a1 1 0 0 0 1 1"
      />
    </svg>
  );
};
SvgArrowUp.displayName = displayName;
export default SvgArrowUp;
